
import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

interface ReagentFormActionsProps {
  isSubmitting: boolean;
  onSubmit: (e?: React.FormEvent) => void;
}

const ReagentFormActions = ({ isSubmitting, onSubmit }: ReagentFormActionsProps) => {
  const navigate = useNavigate();
  
  const handleCancel = () => {
    console.log("Cancel button clicked");
    navigate("/reagents");
  };
  
  const handleSubmit = (e: React.MouseEvent) => {
    console.log("Submit button clicked");
    e.preventDefault();
    
    if (!isSubmitting) {
      console.log("Calling onSubmit function...");
      onSubmit();
      console.log("onSubmit function called successfully");
    } else {
      console.log("Already submitting, ignoring click");
    }
  };
  
  return (
    <div className="flex justify-between w-full">
      <Button 
        variant="outline" 
        onClick={handleCancel}
        disabled={isSubmitting}
        type="button"
      >
        Cancel
      </Button>
      <Button 
        disabled={isSubmitting}
        onClick={handleSubmit}
        type="button" // Changed from "submit" to "button" to prevent double submission
        className="min-w-[140px]"
      >
        {isSubmitting ? (
          <span className="flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            Uploading...
          </span>
        ) : (
          "Upload Reagent"
        )}
      </Button>
    </div>
  );
};

export default ReagentFormActions;
